/**
 * Concept page anatomy (founder redesign concept 2026-09-20) shared by the
 * workspace hub pages — Tools, Settings & help, Billing & usage:
 *   .page-heading  eyebrow · h1 · p   (+ optional action)
 *   .feature-card  eyebrow badge · h3 title ↗ · p   (the whole card is the link)
 *   .note-bar      a closing note
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import './Hub.css';

export function HubHeading({ eyebrow, title, description, action }: {
    eyebrow: string; title: string; description?: React.ReactNode; action?: React.ReactNode;
}) {
    return (
        <header className="hub-heading">
            <div className="hub-heading-main">
                <p className="hub-eyebrow">{eyebrow}</p>
                <h1 className="hub-title">{title}</h1>
                {description && <p className="hub-description">{description}</p>}
            </div>
            {action && <div className="hub-heading-action">{action}</div>}
        </header>
    );
}

export function FeatureCard({ to, title, description, badge, label }: {
    to: string; title: string; description: string; badge?: string; label?: string;
}) {
    return (
        <Link to={to} className="hub-feature-card" aria-label={label}>
            {badge && <span className="hub-eyebrow hub-feature-badge">{badge}</span>}
            <h3 className="hub-feature-title">
                {title}
                <ArrowUpRight size={17} aria-hidden="true" />
            </h3>
            <p className="hub-feature-description">{description}</p>
        </Link>
    );
}

export function NoteBar({ children }: { children: React.ReactNode }) {
    return <p className="hub-note-bar">{children}</p>;
}
